import { Button, Form, Input, Tooltip, Typography } from 'antd';
import React from 'react';
import { GenericObject } from '../../../utils/types';

type Props = {
  label: string;
  name: string;
  rules?: Array<any>;
  required?: boolean;
  editable?: boolean;
  value?: string;
  validateFields?: Function;
};

const FormItemWrapper = ({
  label,
  name,
  rules,
  required = false,
  editable = true,
  value,
  validateFields,
}: Props) => {
  const [editMode, setEditMode] = React.useState<boolean>(false);

  const handleButtonclick = () => {
    validateFields?.()
      .then(() => {
        setEditMode(!editMode);
      })
      .catch((errorInfo: GenericObject) => {
        if (
          !errorInfo.errorFields.some(
            (item: GenericObject) => item.name[0] === name
          )
        ) {
          setEditMode(!editMode);
        }
      });
  };

  return (
    <Form.Item label={label} required={required}>
      <Form.Item
        style={editable && editMode ? {} : { display: 'none' }}
        name={name}
        rules={rules}
        noStyle={editable && editMode}
        shouldUpdate
      >
        <Input onBlur={handleButtonclick} />
      </Form.Item>

      {(!editable || !editMode) && (
        <Tooltip title={value}>
          <Typography.Text style={{ maxWidth: '225px' }} ellipsis={true}>
            {value}
          </Typography.Text>
        </Tooltip>
      )}

      {!editMode && editable && (
        <Button style={{ padding: 0 }} type="link" onClick={handleButtonclick}>
          {editMode ? 'Save' : 'Edit'}
        </Button>
      )}
    </Form.Item>
  );
};

export default FormItemWrapper;
